import TYPES from './types';

export const INITIAL_STATE = {
    estimates: [],
    loaded: false,
};

export const INIT = function () {
    return { ...INITIAL_STATE };
};

const EstimateReducer = function (state, action) {
    switch (action.type) {
        case TYPES.INIT: {
            return { ...INITIAL_STATE };
        }
        case TYPES.SET_ESTIMATE_LOADING: {
            return { ...state, loaded: false };
        }
        case TYPES.SET_ESTIMATE_LOADED: {
            return { ...state, loaded: true };
        }
        case TYPES.SET_ESTIMATES: {
            const estimate = action.payload;
            const newEstimates = [ ...state.estimates, estimate ];

            return { ...state, estimates: newEstimates };
        }
        default: {
            return { ...state };
        }
    }
};

export default EstimateReducer;
